<template>
  <OverviewCard
    :title="$t('key_dashboard_stock_breaks')"
    :loading="loading"
    :error="error"
    :empty="!data.items.length"
  >
    <div class="table-responsive">
      <table class="table align-items-center mb-0">
        <thead>
          <tr>
            <th class="text-uppercase text-xxs text-secondary font-weight-bold ps-0">{{ $t("key_dashboard_code") }}</th>
            <th class="text-uppercase text-xxs text-secondary font-weight-bold">{{ $t("key_dashboard_product") }}</th>
            <th class="text-uppercase text-xxs text-secondary font-weight-bold text-end pe-0">{{ $t("key_dashboard_times") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data.items" :key="item.ean">
            <td class="text-xs ps-0">{{ item.ean }}</td>
            <td class="text-xs text-uppercase">{{ item.name || "—" }}</td>
            <td class="text-xs font-weight-bold text-end pe-0">{{ format(item.times) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </OverviewCard>
</template>

<script>
import OverviewCard from "./OverviewCard.vue";
import { formatNumber } from "./shared";

export default {
  name: "StockBreaks",
  components: { OverviewCard },
  props: {
    data: { type: Object, default: () => ({ items: [] }) },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
  },
  methods: {
    format(value) {
      return formatNumber(value, this.$i18n.locale);
    },
  },
};
</script>
